export const routes = {
  editPaymentMode: {
    path: "paymentMode/:id/edit/",
    name: "editPaymentMode",
  },
  paymentModes: {
    path: "/paymentModes",
    name: "paymentModes",
  },
};
